import { render } from "./MessageListItem.vue?vue&type=template&id=601b51c4&scoped=true"
import script from "./MessageListItem.vue?vue&type=script&lang=js"
export * from "./MessageListItem.vue?vue&type=script&lang=js"

import "./MessageListItem.vue?vue&type=style&index=0&id=601b51c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-601b51c4"

export default script